var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoftoffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 326,
    viewBox: "0 0 256 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.907 28.2923C242.8 32.4055 253.095 45.8034 253.095 61.0681V264.397C253.095 279.799 242.582 293.246 227.495 297.246L134.227 323.42L164.206 259.88V57.86L138.768 2.22363L227.907 28.2923Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.198 251.799V283.532C164.198 314.263 133.297 334.029 107.479 319.823L51.4304 283.904C44.9496 280.138 41.4425 272.09 43.6405 264.049C45.6849 256.566 52.6991 251.799 60.0769 251.799H164.198Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.287 5.54551L18.9312 60.3819C8.83018 66.1354 2.5918 76.8586 2.5918 88.4788V237.4C2.5918 248.366 14.3817 255.299 23.9655 249.958L60.1029 229.828C64.5069 227.38 67.2383 222.725 67.2383 217.683V112.35C67.2383 101.788 73.5413 92.3091 83.1009 88.5192L164.208 60.3495V35.3799C164.208 9.48895 137.291 -6.92317 115.287 5.54551Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 193.661,
    y1: 24.2358,
    x2: 193.661,
    y2: 297.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#E38400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171,
    stopColor: "#DB6200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.299,
    stopColor: "#D44A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#D03B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#CF3600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#D22900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D42400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 50.4365,
    y1: 251.403,
    x2: 172.691,
    y2: 300.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F52537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#F32536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#EA2434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#DC2231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#C8202C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#AE1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#8F1A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -18.5637,
    y1: 229.893,
    x2: 147.028,
    y2: -16.6444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D96AB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#D9538B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D91A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#D31A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#C21926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#A71821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#811619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#691515"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftoffice);
export default __webpack_public_path__ + "static/media/microsoftoffice.c3a1f4f1a4b45604542ec493ff02aefa.svg";
export { ForwardRef as ReactComponent };